var app = angular.module('app')
    .filter('formatOrdinalSuffix', formatOrdinalSuffix);

function formatOrdinalSuffix () {
    return n => {
        var test1_3 = n % 10;
        var test11_13 = n % 100;
        var suffix;

        if (test1_3 == 1 && test11_13 != 11) {
            suffix = 'st';
        }
        else if (test1_3 == 2 && test11_13 != 12) {
            suffix = 'nd';
        }
        else if (test1_3 == 3 && test11_13 != 13) {
            suffix = 'rd';
        }
        else {
            suffix = 'th';
        }

        return n + suffix;
    }
}